module.exports = __webpack_public_path__ + "media/g3.8c2ffea4.mp3";